<template>
  <div class="lime-body">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
        <flash-message  id="flash-message" ></flash-message>
            <loading :active.sync="isLoading" 
                :can-cancel="true" 
                :is-full-page="fullPage"></loading>
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb breadcrumb-separator-1">
              <!--<li class="breadcrumb-item"><a href="#">Pages</a></li>-->
              <li class="breadcrumb-item active" aria-current="page">Invoice</li>
            </ol>
          </nav>
          <div class="page-title">
            <h3>Invoice List</h3>
            <div class="search-create">
              <div class="search">
                <input class="form-control mr-sm-2"  v-model="filter" @keydown="$event.stopImmediatePropagation()" type="text" placeholder="Search Invoice" aria-label="Search" />
              </div>
              <button class="btn btn-primary" id="invoiceBtn" v-on:click="adInvoice()"><i class="material-icons">add</i> Add Invoice</button>
            </div>
          </div>
          <div class="row">
          </div>
          </div>
        </div>
      <div class="row">
        <div class="col-md-12">
        <p style="color:red;text-align:center">{{ msg }}</p>
          <div class="table-responsive">
              <datatable :class="tblCls" :columns="columns" :filter="filter" :per-page="10" :data="invoicesList"></datatable>   
              <datatable-pager v-model="page" class="pagination"></datatable-pager>
            </div>
         </div>
      </div>
    </div>
  
  </div>
</template>
<script>
import axios from 'axios'
import AdminDashboard from './AdminDashboard'
import invoiceAction from './invoiceAction'
import AddInvoice from './AddInvoice'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
require('vue-flash-message/dist/vue-flash-message.min.css')
export default {
  name: 'Invoice',
  components: { AddInvoice, AdminDashboard,
    Loading
  },
  data () {
    return {
      msg: '',
      isLoading: false,
      fullPage: true,
      validated:false,
      errorMessage: '',
      tblCls: 'table',
      date: '2019-10-01 00:00:00',
      invoicesList: [],
      invoices: [],
      realtime: '',
      brands: [],
      users: [],
      invoiceDatas: [],
      invoicePartiesPercentageDatas: [],
      BrandDatas: [],
      errors: [],
      i: 0,
      invoiceDetails: {
        InvoiceData: {
          amount: '',
          description: '',
          uid: '',
          invoice_percentage_id: '',
          brand_id: ''
        },
        invoicePercentageData: {
          admin_percentage: '',
          userA_percentage: '',
          userB_percentage: '',
          userC_percentage: '',
          admin_id: '',
          userA_id: '',
          userB_id: '',
          userC_id: ''
        }
      },
      input: {
        brandid: '',
        amount: '',
        admin: '',
        descrition: '',
        adminpercent: '',
        userA: '',
        userApercent: '',
        userB: '',
        userBpercent: '',
        userC: '',
        userCpercent: '',
        duedays: '',
        invoicetype: ''
      },
      selectedBrand: '',
      selecteduserA: '',
      selecteduserB: '',
      selecteduserC: '',
      selectedDays: '',
      statusInvoice: '',
      columns: [
        {label: 'Invoice No.', field: 'id'},
        {label: 'Brand', field: 'brand_name'},
        {label: 'Payment', field: 'amount', headerClass: 'class-in-header second-class'},
        {label: 'Escrow', field: 'admin_percentage'},
        {label: 'User A', field: 'userA_percentage'},
        {label: 'User B', field: 'userB_percentage'},
        {label: 'User C', field: 'userC_percentage'},
        {label: 'Status',
          field: 'status',
          interpolate: true,
          representedAs: function (row) {
            if (row.status === 'open') {
              return ` <span style="color:red">${row.status}</span> `
            } else if (row.status === 'draft') {
              return ` <span style="color:blue">${row.status}</span> `
            } else if (row.status === 'past due') {
              return ` <span style="color:#570702">${row.status}</span> `
            } else {
              return ` <span style="color:green">${row.status}</span> `
            }
          }
        },
        {label: 'Action',
          component: invoiceAction,
          sortable: false
        }
      ],
      rows: this.invoicesList,
      filter: '',
      page: 1
    }
  },
  methods: {

    invoiceBtn () {
      var modal = document.getElementById('createInvoice')
      modal.style.display = 'block'
    },
    invoiceClose () {
      this.input.amount = ''
      this.input.description = ''
      this.input.adminpercent = ''
      this.input.userApercent = ''
      this.input.userBpercent = ''
      this.input.userCpercent = ''
      this.input.brandid = ''
      this.input.admin = ''
      this.input.userA = ''
      this.input.userB = ''
      this.input.userC = ''
      this.input.duedays = ''
      document.getElementById('brand-logo').style.display = 'none'
      document.getElementById('brandDetail').style.display = 'none'
      document.getElementById('userApercent').disabled = true
    },
    adInvoice () {
      this.$modal.show(AddInvoice, { height: '100%' })
    },
    createInvoicePopup () {
      var modal = document.getElementById('createInvoice')
      var span = document.getElementById('invoiceClose')
      span.onclick = function () {
        modal.style.display = 'none'
        document.getElementById('userApercent').disabled = true
        document.getElementById('userBpercent').disabled = true
        document.getElementById('userCpercent').disabled = true
      }
      window.onclick = function (event) {
        if (event.target === modal) {
          modal.style.display = 'none'
        }
      }
    },
    changeBrand (event) {
      this.selectedBrand = event.target.options[event.target.options.selectedIndex].value
    },
    changeDays (event) {
      this.selectedDays = event.target.options[event.target.options.selectedIndex].value
    },
    getBrands () {
      var jwttoken = localStorage.getItem('jwt')
      this.isLoading = true
      axios.get('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/getAllBrands', {
        headers: {
          'x-access-token': jwttoken
        }})
        .then(response => {
          this.isLoading = false
          this.brands = response.data.results
        })
        .catch((error) => {
          this.errorMessage = error.response.data.errors
          this.isLoading = false
        })
    },
    getInvoice () {
      var jwttoken = localStorage.getItem('jwt')
      this.isLoading = true
      this.invoicesList = []
      axios.get('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/getAllInvoices', {
        headers: {
          'x-access-token': jwttoken
        }})
        .then(response => {
          this.invoices = response.data.results
          
          for (var i in this.invoices) {
            var obj = this.invoices[i]

            //var amount = Number(obj.amount).toLocaleString()
            this.invoicesList.push({
              id: obj.invoice_number,
              uid: obj.invoice_id,
              amount: obj.amount,
              brand_name: obj.brand_name,
              admin_percentage: obj.escrowUser_percentage+'%'+' ('+obj.escrowUser_amount+')',
              userA_percentage: obj.userA_percentage+'%'+' ('+obj.userA_amount+')',
              userB_percentage: obj.userB_percentage+'%'+' ('+obj.userB_amount+')',
              userC_percentage: obj.userC_percentage+'%'+' ('+obj.userC_amount+')',
              status: obj.status,
              manual_payment: obj.manual_payment,
              invoice_type: obj.invoice_type
            })
            this.isLoading = false
          }
        })
        .catch((error) => {
          console.log(error.response.data.errors)
          this.isLoading = false
        })
    },
    showInvoice (invoiceId) {
      var jwttoken = localStorage.getItem('jwt')
      this.isLoading = true
      axios.get('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/getInvoiceById' + '?' + 'invoice_id' + '=' + invoiceId, {
        headers: {
          'x-access-token': jwttoken
        }})
        .then(response => {
          console.log(response)
          this.isLoading = false
        
        })
        .catch((error) => {
          this.errorMessage = error.response.data.errors
          this.isLoading = false
        })
    }
  },
  created () {
    this.getBrands()
  },
  mounted () {
    this.$eventBus.$on('listInvoice', (data,error,time) => { 
          const messageStorage = this.flash();
          if (data) {  
             this.getInvoice() ;
             this.$forceUpdate();
             messageStorage.destroyAll()
             if(time){
             this.flash(data, 'success', {timeout: time }); 
             }else {
              this.flash(data, 'success', {timeout: 3000 }); 
             }
          }
          else if (error) { 
            if(time){
             this.flash(error, 'error', {timeout: time });
            }else {
              this.flash(error, 'error', {timeout: 3000 });
            }
         
          }
      }) 
    this.getInvoice()        
    document.getElementById('userApercent').disabled = true
    document.getElementById('userBpercent').disabled = true
    this.createInvoicePopup()
  },
  watch: {
    $route (to, from) {
      this.msg = this.$router.currentRoute.query.errorMessage
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Invoice.vue